export * from './post-bereich.service';
export * from './post-bereich.service.module';